import { Component } from '@angular/core';

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.css'],
    standalone: false
})
export class MyAccountComponent {
  
  constructor() {
  }
}
